import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import HeroSection from './HeroSection';
import ServicesSection from './ServicesSection';
import ProjectGallery from './ProjectGallery';
import CTABlock from './CTABlock';
import TestimonialsSection from './TestimonialsSection';
import { staggerContainer, fadeInUp } from '../lib/animations';

const LandingPage = () => {
  return (
    <>
      <Helmet>
        <title>Air Conditioning &amp; Building Services Havering &amp; Essex | Fallow</title>
        <meta name="description" content="Havering's leading air conditioning and building specialists. AC installation, extensions, loft conversions, roofing and property maintenance across Essex. CIS-registered. Call 0203 576 5962." />
        <meta property="og:title" content="Air Conditioning & Building Services Havering & Essex | Fallow" />
        <meta property="og:description" content="Air conditioning, extensions, loft conversions and property maintenance from Havering's leading specialists, with systems matched to your budget. CIS-registered, fully insured. 150+ projects delivered." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://fallowbuildingservices.co.uk/" />
        <link rel="canonical" href="https://fallowbuildingservices.co.uk/" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      </Helmet>

      <motion.div 
        className="landing-page"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      >
        {/* Hero Section - Already has its own animations */}
        <section>
          <HeroSection />
        </section>

        {/* Services Section with scroll animation */}
        <motion.section 
          variants={fadeInUp}
          className="landing-section"
        >
          <ServicesSection />
        </motion.section>

        {/* Project Gallery Placeholder */}
        <motion.section 
          variants={fadeInUp}
          className="landing-section"
        >
          <ProjectGallery />
        </motion.section>

        {/* Testimonials Section */}
        <motion.section 
          variants={fadeInUp}
          className="landing-section"
        >
          <TestimonialsSection />
        </motion.section>

        {/* CTA Block */}
        <motion.section 
          variants={fadeInUp}
          className="landing-section landing-section-cta"
        >
          <CTABlock />
        </motion.section>
      </motion.div>
    </>
  );
};

export default LandingPage;
